<template>
  <div style="margin:20px 0">
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="data"
      ref="table"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
    </Table>
    <Table
      border
      :loading="loading"
      v-show="false"
      :columns="columnsA"
      :data="exportDataList"
      ref="tableRef"
    ></Table>
    <div
      style="margin:20px 0;display:flex; justify-content: flex-end;flex-direction: column; align-items: flex-end;"
    >
      <Page
        :total="total"
        :current="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        transfer
        @on-change="pageChange"
        :page-size-opts="[10, 50, 100, 150]"
        show-sizer
        @on-page-size-change="pageSizeChange"
      />
      <Button type="primary" style="margin-top:15px" @click="exportData()"
        ><!-- 导出 -->{{ $t("PB_Export") }}</Button
      >
    </div>
  </div>
</template>

<script>
import DateUtil from "../../../../../util/DateUtil";
import axios from "axios";
export default {
  data() {
    return {
      date: new DateUtil(),
      loading: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      data: [],
      exportDataList: [],
      spanb: [],
      spanc: [],
      searchItem: {}
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("Check") /* 查看 */,
          slot: "action",
          align: "center",
          minWidth: 80,
          fixed: "left"
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Position") /* 职位 */,
          key: "position",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: "dirSupUserName",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Start_Date") /* 开始日期 */,
          key: "startDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.startDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("End_Date") /* 结束日期 */,
          key: "endDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.endDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("STI_Self") /* STI个人目标 */,
          key: "stiTarget",
          align: "center",
          minWidth: 330
        },
        {
          title: this.$t("Detailed_Description") /* 详情描述 */,
          key: "details",
          align: "center",
          minWidth: 330
        },
        {
          title: this.$t("Milestone1") /* 里程碑1 */,
          key: "milepost1",
          align: "center",
          minWidth: 300
        },
        {
          title: this.$t("Milestone2") /* 里程碑2 */,
          key: "milepost2",
          align: "center",
          minWidth: 300
        },
        {
          title: this.$t("Milestone3") /* 里程碑3 */,
          key: "milepost3",
          align: "center",
          minWidth: 300
        },
        {
          title: this.$t("Data_Source") /* 数据来源 */,
          key: "dataSource",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Employee_Self-Evaluation") /* 员工自评 */,
          key: "scheduleFollowUp",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Milestones_Obtained") /* 达成比例 */,
          key: "reachRatio",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Completion_Status") /* 实际完成情况 */,
          key: "finishDataSource",
          align: "center",
          minWidth: 160
        },
        // {
        //     title:this.$t('Attachment'),/* 附件 */
        //     key: "attachment",
        //     align: "center",
        //     minWidth:120
        // },
        {
          title: this.$t("Dotted-Line_Manager_Appraisal") /* 虚线上级反馈*/,
          key: "indirSupFeedback",
          align: "center",
          minWidth: 160
        },
        {
          title: this.$t("Line_Manager_Appraisal") /* 直线上级评估 */,
          key: "dirSupFeedback",
          align: "center",
          minWidth: 160
        },
        {
          title: this.$t("HRBP_Name") /* HRBP姓名 */,
          key: "hrbpUserName",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("STI_update_status") /* STI更新状态 */,
          key: "stiStatus",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Adjust_To") /* 特殊调整 */,
          key: "specialAdjust",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Remarks") /* 备注 */,
          key: "specialComment",
          align: "center",
          minWidth: 120
        }
      ];
    },
    columnsA() {
      return [
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
          fixed: "left"
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Position") /* 职位 */,
          key: "position",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: "dirSupUserName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Start_Date") /* 开始日期 */,
          key: "startDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.startDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("End_Date") /* 结束日期 */,
          key: "endDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.endDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("STI_Self") /* STI个人目标 */,
          key: "stiTarget",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Detailed_Description") /* 详情描述 */,
          key: "details",
          align: "center",
          minWidth: 330
        },
        {
          title: this.$t("Milestone1") /* 里程碑1 */,
          key: "milepost1",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Milestone2") /* 里程碑2 */,
          key: "milepost2",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Milestone3") /* 里程碑3 */,
          key: "milepost3",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Data_Source") /* 数据来源 */,
          key: "dataSource",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Self-Evaluation") /* 员工自评 */,
          key: "scheduleFollowUp",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Milestones_Obtained") /* 达成比例 */,
          key: "reachRatio",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Completion_Status") /* 实际完成情况 */,
          key: "finishDataSource",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Dotted-Line_Manager_Appraisal") /* 虚线上级反馈*/,
          key: "indirSupFeedback",
          align: "center",
          minWidth: 160
        },
        {
          title: this.$t("Line_Manager_Appraisal") /* 直线上级评估 */,
          key: "dirSupFeedback",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("HRBP_Name") /* HRBP姓名 */,
          key: "hrbpUserName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("STI_update_status") /* STI更新状态 */,
          key: "stiStatus",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Adjust_To") /* 特殊调整 */,
          key: "specialAdjust",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Remarks") /* 备注 */,
          key: "specialComment",
          align: "center",
          minWidth: 120
        }
      ];
    }
  },
  methods: {
    pageChange(val) {
      this.$emit("pageChange", val);
    },
    pageSizeChange(val) {
      this.$emit("pageSizeChange", val);
    },
    exportData() {
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        pageNo: 1,
        pageSize: 99999
      };
      this.loading = true;
      axios.post("/achReport/selectStiTargetInfo", obj).then(res => {
        if (res) {
          res.data.forEach(item => {
            item.startDate = this.date.dateVal(item.startDate, "YYYY-MM-DD");
            item.endDate = this.date.dateVal(item.endDate, "YYYY-MM-DD");
          });
          this.$nextTick(() => {
            this.$exportExcel(
              "tableRef",
              `${this.$t("STI_Self")}-${this.$t("STI_Update")}` +
                this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm"),
              res.data
            ); /* 'STI个人目标-STI更新' */
          });
        }
        this.loading = false;
      });
    },
    checkBtn(row, index) {
      const href =
        "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27/?id=" +
        row.id +
        "&serialnumber=" +
        row.serialnumber +
        "&year=" +
        row.year +
        "&userName=" +
        row.userName +
        "&returnFlag='1'";
      window.open(href, "_blank");
      // this.$router.push({
      //     path: '/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27',
      //     query: { id: row.id ,serialnumber:row.serialnumber,year:row.year}
      // })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/tableComponents/STIPersonalGoalsD.vue